import moment from "moment";

/**
 * Check if the given date is in the same week as today.
 *
 * @param {Date} date
 * @returns {boolean}
 */
export const isCurrentWeek = (date) => {
  return moment(date).isSame(moment, 'week');
};
